import { Api } from '../index';

export const fetchFollowTracks = () => Api.get('/offers/follow/tracks');

export const followTrack = ({ payload }) =>
  Api.post('orders/follow/tracks', payload);
